import React, { useState } from "react";
import { login, changePassword } from "../api";
import { errMsg } from "../utils";

const LOGO = process.env.PUBLIC_URL + "/fs-black.png";
const MIN_LENGTH = 8;

/** Pantalla de ingreso: email + contraseña. */
export function Login({ info, onDone, onMustChange }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError("Ingresa tu correo y contraseña.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await login(email, password);
      if (res.mustChange) {
        // El backend exige cambio de contraseña antes de emitir token.
        onMustChange(email.trim(), password);
        return;
      }
      onDone();
    } catch (e2) {
      const status = e2?.response?.status;
      if (status === 401) {
        setError("Correo o contraseña incorrectos.");
      } else if (status === 423) {
        // Usuario bloqueado temporalmente: mostrar el mensaje del backend.
        setError(errMsg(e2, "Usuario bloqueado temporalmente. Intenta más tarde."));
      } else {
        setError(errMsg(e2, "No se pudo iniciar sesión."));
      }
      setLoading(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo">
          <span className="badge-logo"><img src={LOGO} alt="ALAS" /></span>
          <h1>Portal de Proveedores</h1>
          <div className="sub">ALAS · Reservas de convenio</div>
        </div>

        {info && !error && <div className="banner info">{info}</div>}
        {error && <div className="banner err">{error}</div>}

        <label>Correo electrónico</label>
        <input
          type="email"
          inputMode="email"
          autoComplete="username"
          autoCapitalize="none"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="tu@empresa.com"
        />

        <label>Contraseña</label>
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Tu contraseña"
        />

        <button className="btn" style={{ marginTop: 24 }} disabled={loading}>
          {loading ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}

/**
 * Cambio de contraseña OBLIGATORIO (must_change_password en el login).
 * Cambia con /auth/change-password y luego intenta el auto-login con la
 * contraseña nueva; si ese segundo paso falla, vuelve al login con aviso.
 */
export function ChangePassword({ email, currentPassword, onDone, onBackToLogin }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError("");
    if (newPassword.length < MIN_LENGTH) {
      setError(`La nueva contraseña debe tener al menos ${MIN_LENGTH} caracteres.`);
      return;
    }
    if (newPassword !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    if (newPassword === currentPassword) {
      setError("La nueva contraseña debe ser diferente a la actual.");
      return;
    }
    setLoading(true);

    // Paso 1: cambiar la contraseña.
    try {
      await changePassword(email, currentPassword, newPassword);
    } catch (e2) {
      setError(errMsg(e2, "No se pudo cambiar la contraseña."));
      setLoading(false);
      return;
    }

    // Paso 2: la contraseña YA se cambió; auto-login para no pedirla de nuevo.
    try {
      const res = await login(email, newPassword);
      if (res.mustChange) throw new Error("Cambio no aplicado");
      onDone();
    } catch {
      onBackToLogin("Tu contraseña fue cambiada. Ingresa con tu nueva contraseña.");
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo">
          <span className="badge-logo"><img src={LOGO} alt="ALAS" /></span>
          <h1>Cambia tu contraseña</h1>
          <div className="sub">Por seguridad debes actualizarla antes de continuar.</div>
        </div>

        <div className="banner info">
          🔒 Mínimo {MIN_LENGTH} caracteres y distinta a la anterior.
        </div>

        {error && <div className="banner err">{error}</div>}

        <label>Nueva contraseña</label>
        <input
          type="password"
          autoComplete="new-password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Nueva contraseña"
          autoFocus
        />

        <label>Confirmar contraseña</label>
        <input
          type="password"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          placeholder="Repite la contraseña"
        />

        <button className="btn" style={{ marginTop: 24 }} disabled={loading}>
          {loading ? "Guardando…" : "Guardar y continuar"}
        </button>
        <button
          type="button"
          className="btn ghost"
          style={{ marginTop: 10 }}
          onClick={() => onBackToLogin("")}
          disabled={loading}
        >
          Volver al inicio de sesión
        </button>
      </form>
    </div>
  );
}
